import React from 'react'

const CryptovoxelsInstance = () => {
  return (
    <iframe
      title='Metafest Booth'
      src='https://www.cryptovoxels.com/play?coords=S@379E,115S'
      style={{ height: '100%', width: '100%', border: '0px' }}
    />
  )
}

export default CryptovoxelsInstance
